import React from 'react'
import './AreaIcon.scss'

// Figma "Icon / Inbox" (Lucide inbox, 24er-Raster). Die Varianten füllen die Schale
// oben hell und die Ablage unten kräftiger.
const OUTLINE =
  'M2 12L5.45 5.11C5.62 4.78 5.87 4.5 6.19 4.3C6.5 4.1 6.87 4 7.24 4H16.76C17.13 4 17.5 4.1 17.81 4.3C18.13 4.5 18.38 4.78 18.55 5.11L22 12V18C22 18.53 21.79 19.04 21.41 19.41C21.04 19.79 20.53 20 20 20H4C3.47 20 2.96 19.79 2.59 19.41C2.21 19.04 2 18.53 2 18V12Z'
const TRAY_LINE = 'M22 12H16L14 15H10L8 12H2'
const SHELL_FILL =
  'M2 12L5.45 5.11C5.62 4.78 5.87 4.5 6.19 4.3C6.5 4.1 6.87 4 7.24 4H16.76C17.13 4 17.5 4.1 17.81 4.3C18.13 4.5 18.38 4.78 18.55 5.11L22 12H16L14 15H10L8 12H2Z'
const TRAY_FILL = 'M2 12H8L10 15H14L16 12H22V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V12Z'

const Variant: React.FC<{ className: string; size: number; stroke: string; shell?: string; tray?: string; lines?: boolean }> = ({
  className,
  size,
  stroke,
  shell,
  tray,
  lines,
}) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {shell && <path d={SHELL_FILL} fill={shell} />}
    {tray && <path d={TRAY_FILL} fill={tray} />}
    <path d={TRAY_LINE} stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    {lines && <path d="M8.5 6.5H15.5M7.5 9H16.5" stroke={stroke} strokeWidth="2" strokeLinecap="round" />}
    <path d={OUTLINE} stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const AreaIcon: React.FC<{ size?: number; className?: string }> = ({ size = 16, className }) => (
  <span className={`area-icon ${className || ''}`} style={{ display: 'inline-flex', width: size, height: size }}>
    <Variant className="area-icon__rest" size={size} stroke="currentColor" />
    <Variant className="area-icon__preview" size={size} stroke="#57534E" shell="#EEEDEC" tray="#A8A29E" />
    <Variant className="area-icon__active" size={size} stroke="#6D28D9" shell="#EDE9FE" tray="#A78BFA" />
    <Variant className="area-icon__active-work" size={size} stroke="#4338CA" shell="#E0E7FF" tray="#818CF8" />
    <Variant className="area-icon__active-home" size={size} stroke="#0F766E" shell="#F0FDFA" tray="#14B8A6" />
    <Variant className="area-icon__active-filled" size={size} stroke="#6D28D9" shell="#EDE9FE" tray="#C4B5FD" lines />
  </span>
)
